import { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { useDebounce } from 'use-debounce';
import { PickProjectDialogProjectsDocument } from './query.gql';
const LIMIT = 20;
export function useProjects() {
    var _a, _b;
    const [searchQuery, setSearchQuery] = useState('');
    const [offset, setOffset] = useState(0);
    const [debouncedSearchQuery] = useDebounce(searchQuery, 250);
    const { data, previousData, loading } = useQuery(PickProjectDialogProjectsDocument, {
        variables: { query: debouncedSearchQuery, limit: LIMIT, offset },
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'cache-and-network',
    });
    const { results = [], totalHitsCount = 0 } = (_b = (_a = (data !== null && data !== void 0 ? data : previousData)) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : {};
    const projects = results.flatMap((result) => {
        var _a;
        // eslint-disable-next-line no-underscore-dangle
        return result.__typename === 'SearchResultProject'
            ? {
                id: result.entityId,
                name: result.name,
                customerId: (_a = result.metadataProjectCustomerId) !== null && _a !== void 0 ? _a : undefined,
                documentsCount: result.metadataProjectDocumentsCount,
                status: result.metadataProjectStatus,
            }
            : [];
    });
    const search = (query) => {
        setSearchQuery(query);
        setOffset(0);
    };
    const clearSearch = () => search('');
    return {
        projects,
        count: totalHitsCount,
        limit: LIMIT,
        offset,
        setOffset,
        loading,
        searchQuery,
        search,
        clearSearch,
    };
}
